export interface Resident {
    sid: string;
    fullName: string;
    firstName: string;
    surname: string;
    email: string;
    mobileNumber: string;
    department: string;
    employeeNumber: string;
    signatureBase64: string;
    signaturePoints?: number;
    departmentContactName: string;
    departmentContactNumber: string;
    readAndAgreedWithRules: boolean;
    hasIncorrectPersonalDetails: boolean;
    publicUser: boolean;
    ruleHtml: string;
    ruleVersion: string;
    supervisorName: string;
    supervisorMobile: string;
  }

  export class Resident implements Resident {
    constructor(init?: ResidentFormValues) {
      Object.assign(this, init);
    }
  }

  export class ResidentFormValues {  
    sid?: string = undefined;
    fullName?: string = undefined;
    firstName?: string = undefined;
    surname?: string = undefined;
    email?: string = undefined;
    mobileNumber?: string = undefined;
    department?: string = undefined;
    signatureBase64?: string = undefined;
    signaturePoints?: number = undefined;
    employeeNumber?: string = undefined;
    departmentContactName?: string = undefined;
    departmentContactNumber?: string = undefined;
    readAndAgreedWithRules?: boolean | false;
    hasIncorrectPersonalDetails?: boolean | false;
    publicUser?: boolean | false;
    ruleVersion?: string = undefined;
    supervisorName?: string = undefined;
    supervisorMobile?: string = undefined;

    constructor(resident?: ResidentFormValues) {
      if (resident) {
        this.sid = resident.sid;
        this.fullName = resident.fullName;        
        this.email = resident.email;
        this.mobileNumber = resident.mobileNumber;
        this.department = resident.department;
        this.employeeNumber = resident.employeeNumber;
        this.departmentContactName = resident.departmentContactName;
        this.departmentContactNumber = resident.departmentContactNumber;
        this.publicUser = resident.publicUser;
        this.ruleVersion = resident.ruleVersion;
        this.supervisorName = resident.supervisorName;
        this.supervisorMobile = resident.supervisorMobile; 
      }
    }    
  }

  export class ConfirmedResident {      
    fullName?: string = undefined;   
    email?: string = undefined;
    mobileNumber?: string = undefined;
    signatureBase64?: string = undefined;
    employeeNumber?: string = undefined;
    ruleVersion?: string = undefined;    


    constructor(resident?: ResidentFormValues) {
      if (resident) {
        this.fullName = resident.fullName ? resident.fullName : resident.firstName + ' ' + resident.surname;
        this.email = resident.email;
        this.mobileNumber = resident.mobileNumber;
        this.employeeNumber = resident.employeeNumber;
        this.signatureBase64 = resident.signatureBase64;
        this.ruleVersion = resident.ruleVersion;
      }
    }
  }

